import Modal from '../../../../../commons/Modal/Modal';
import { DashboardCompaniesFiltersModalProps } from './DashboardCompaniesFiltersModal.types';
import DashboardCompaniesFiltersForm from './DashboardCompaniesFiltersForm/DashboardCompaniesFiltersForm';
import { ModalSizes } from '../../../../../commons/Modal/Modal.types';

export default ({ ...props }: DashboardCompaniesFiltersModalProps) => {
  return (
    <Modal 
      className="dashboard__companies-filters" 
      size={ModalSizes.Small}
      closeOnClickOutside 
      {...props}
    >
      {/* <h2 className="dashboard__companies-filters-title">Filtrer</h2> */}
      <DashboardCompaniesFiltersForm closeModal={() => props.setOpen(false)} />
    </Modal>
  );
};
